import React, { useState, useCallback, memo } from 'react';
import connect from 'Shared/connect';
import Icon from 'Shared/Icon';
import * as styles from './base.scss';
import { translate } from 'Shared/translate';
import classnames from 'classnames';
import AddToListDialog from './AddToListDialog';
export function isInList(listThatActuallyIsObject) {
    return listThatActuallyIsObject && Object.keys(listThatActuallyIsObject).length > 0;
}
const AddRemoveList = memo((props) => {
    const [isAddToListOpen, setAddToListOpen] = useState(false);
    const handleOpenAddToList = useCallback(() => setAddToListOpen(true), []);
    const handleCloseAddToList = useCallback(() => setAddToListOpen(false), []);
    const properties = {
        favorites: {
            isDisabled: props.disableFavoriteList ||
                !props.favoritePageAvailable ||
                !!props.product.isCustom ||
                props.product.isUtf,
            text: translate('/Product/Favorite'),
            uiTestClass: 'ui-test-add-remove-favorites',
            isActive: isInList(props.product.favoritesList),
            iconName: 'heart-outline',
            lists: props.product.favoritesList,
        },
        pantries: {
            isDisabled: props.disablePantry ||
                !props.pantryPageAvailable ||
                props.product.isUtf,
            text: translate('/Product/Pantry'),
            uiTestClass: 'ui-test-add-remove-pantries',
            isActive: isInList(props.product.pantriesList),
            iconName: 'list-bulleted',
            lists: props.product.pantriesList,
        },
    };
    const currentProperties = properties[props.type];
    return currentProperties.isDisabled ? null : (React.createElement("div", { className: styles.listAdd, title: currentProperties.text },
        React.createElement("div", { "data-opti-id": props.type === 'favorites'
                ? 'component-favorite-button'
                : props.type === 'pantries'
                    ? 'component-inventory-button'
                    : undefined, className: classnames(props.className, styles.small, currentProperties.uiTestClass), "data-code": props.code, onClick: handleOpenAddToList },
            React.createElement("div", { className: classnames(styles.circle, {
                    [styles.activeIcon]: currentProperties.isActive,
                    [props.className]: currentProperties.isActive,
                }) },
                React.createElement(Icon, { appearance: "sans", name: currentProperties.iconName }))),
        React.createElement(AddToListDialog, { isOpen: isAddToListOpen, close: handleCloseAddToList, code: props.code, type: props.type, listsContainingProduct: currentProperties.lists })));
});
export default connect((state) => {
    var _a, _b, _c;
    return ({
        disablePantry: state.appShellData.disablePantry,
        disableFavoriteList: state.appShellData.disableFavoriteList,
        favoritePageAvailable: !!((_a = state.appShellData.siteSettings.favoriteOverviewPage) === null || _a === void 0 ? void 0 : _a.url),
        pantryPageAvailable: !!((_b = state.appShellData.siteSettings.favoriteOverviewPage) === null || _b === void 0 ? void 0 : _b.url) &&
            !!((_c = state.appShellData.siteSettings.pantryOverviewPage) === null || _c === void 0 ? void 0 : _c.url),
    });
})(AddRemoveList);
